var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcaeLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.8,46.1c.4-.4.7-1,.7-1.6,0-2.3,1-4.5,2.7-6.3l14.7-14.7c1.8-1.8,4.1-2.8,6.6-2.8s5.1,1.1,6.9,3c3.5,3.7,3.2,9.6-.5,13.3l-14.5,14.5c-1.6,1.6-4.2,2.7-6.3,2.8s-1.3.3-1.7.7c-1.6,1.6-5.3,5.3-5.3,5.3-.4.4-.2,1.1.3,1.3,2,.8,4.2,1.2,6.3,1.2,4.6,0,9.2-1.7,12.7-5.2l14.7-14.7c8.1-8.1,6.8-22.1-3.9-28.3s-2.7-1.3-4.1-1.7c-6.4-1.6-12.8.2-17.2,4.7l-14.7,14.7c-5.1,5.1-6.5,12.6-4.1,18.9s.9.7,1.3.3c0,0,3.7-3.7,5.3-5.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M63.8,54.1c-.5.5-.7,1.1-.7,1.7,0,2-1.3,4.7-2.8,6.2l-14.7,14.7c-1.8,1.8-4.2,2.7-6.6,2.7s-4.8-.9-6.7-2.8c-3.7-3.7-3.7-9.6,0-13.3l14.7-14.7h0c1.6-1.6,3.4-2.7,6.2-2.8s1.3-.3,1.7-.7l5.3-5.3c.4-.4.3-1.1-.3-1.3-2-.8-4.1-1.2-6.3-1.2-4.8,0-9.3,1.9-12.7,5.2l-14.7,14.7c-7,7-7,18.3,0,25.3,3.5,3.5,8.1,5.2,12.7,5.2s9.2-1.7,12.7-5.2l14.7-14.7c3.4-3.4,5.2-7.9,5.2-12.7s-.4-4.3-1.1-6.3-.9-.7-1.3-.3c0,0-3.7,3.7-5.3,5.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcaeLink);
export default __webpack_public_path__ + "static/media/acae_link.879f462b.svg";
export { ForwardRef as ReactComponent };